import React from 'react';
import { BaseSelect, type BaseSelectProps } from '@/core/components/BaseSelect/BaseSelect';
import './InteractionsOriginSelect.scss';

export interface InteractionsOriginSelectProps extends BaseSelectProps {
  label?: string;
}

export const InteractionsOriginSelect: React.FC<InteractionsOriginSelectProps> = ({
  label,
  disabled,
  className = '',
  ...props
}) => {
  const containerClasses = [
    'interactions-origin-select-container',
    disabled ? 'interactions-origin-select-container--disabled' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={containerClasses}>
      {label && (
        <span className="interactions-origin-select-container__label">
          {label}
        </span>
      )}

      <BaseSelect
        className="interactions-origin-select"
        disabled={disabled}
        {...props}
      />
    </div>
  );
};